import script from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangePasswordModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChangePasswordModal.vue?vue&type=style&index=0&id=573b2b2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-573b2b2c"]])

export default __exports__